import { deduplicateArray } from '@caresend/utils';
import { defineComponent, computed } from 'vue';
import __vue_component__ from '../../../../../cards/BasicCard/BasicCard.vue.js';
import { getItineraryWaypointDateTimeInfo } from '../helpers.js';
import __vue_component__$1 from '../../../../../ui/Icon.vue.js';
import { TagStyle } from '../../../../../ui/Tag/model.js';
import __vue_component__$2 from '../../../../../ui/Tag/Tag.vue.js';

var script = defineComponent({
    name: 'ItineraryWaypointInfoCard',
    components: {
        BasicCard: __vue_component__,
        Icon: __vue_component__$1,
        Tag: __vue_component__$2,
    },
    props: {
        waypoint: { type: Object, default: () => null },
    },
    setup(props) {
        const waypointInfo = computed(() => {
            var _a, _b;
            return props.waypoint
                ? deduplicateArray((_b = (_a = getItineraryWaypointDateTimeInfo(props.waypoint)) === null || _a === void 0 ? void 0 : _a.flat()) !== null && _b !== void 0 ? _b : [])
                : undefined;
        });
        const getWaypointInfoTagStyle = (customStyle) => customStyle === 'danger' ? TagStyle['3_ORANGE'] : TagStyle['3_GREY'];
        return {
            getWaypointInfoTagStyle,
            waypointInfo,
        };
    },
});

export { script as default };
